<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Relatório de Posição de Estoque</app-titulo>
      <div class="header-buttons">
        <app-botao type="secundario" class="button" text="Exportar Excel" icon="assets/exportar-excel.svg"
          (click)="exportarExcel()"></app-botao>
        <app-botao type="secundario" class="button" text="Exportar PDF" icon="assets/exportar-excel.svg"
          (click)="exportarPdf()"></app-botao>
      </div>
    </div>
    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Posição por período</div>
        <div class="align-button">
          <form [formGroup]="form" class="table-filters">
            <app-input type="datetime-local" label="Data Início" name="DT_INIC" formControlName="DT_INIC"
              width="100%"></app-input>
            <app-input type="datetime-local" label="Data Final" name="DT_FIM" formControlName="DT_FIM"
              width="100%"></app-input>
            <app-input type="select" label="Produto" name="FK_PROD" formControlName="FK_PROD" width="100%"
              [selectData]="produtoOptions" (ngModelChange)="onSelectChange($event, 'FK_PROD')"></app-input>
          </form>
        </div>
      </div>
      <app-tabela *ngIf="!isLoading" [data]="tableData" [columns]="tableColumns"></app-tabela>
      <div *ngIf="!isLoading && tableData.length" class="rodape-tabela">
        <h2 class="valor">Inicial: {{ totaisFormatados.qtInic }} / {{ totaisFormatados.vlInic }}</h2>
        <h2 class="valor">Saídas: {{ totaisFormatados.qtSaid }} / {{ totaisFormatados.vlSaid }}</h2>
        <h2 class="valor">Atual: {{ totaisFormatados.qtAtual }} / {{ totaisFormatados.vlAtual }}</h2>
      </div>
    </div>
  </div>
  <app-subtitulo *ngIf="!isLoading && !tableData.length">Nenhum registro encontrado.</app-subtitulo>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
